import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import history from 'config/history';

import { AppDispatch } from 'containers/Femtasy';

import { getErrors } from 'helpers/error-helpers';
import { localizeWithCurrentUrl } from 'helpers/locales';

import api from 'api';

type SetNewPasswordError = ReturnType<typeof getErrors> | null;

export interface SetNewPasswordState {
  isLoading: boolean;
  error: SetNewPasswordError;
}

export const initialSetNewPasswordState: SetNewPasswordState = {
  isLoading: false,
  error: null,
};

const setNewPasswordSlice = createSlice({
  name: 'setNewPassword',
  initialState: initialSetNewPasswordState,
  reducers: {
    setNewPasswordLoading: (state) => {
      state.isLoading = true;
    },
    setNewPasswordSuccess: (state) => {
      state.isLoading = false;
      state.error = null;
    },
    setNewPasswordError: {
      reducer: (state, action: PayloadAction<SetNewPasswordError>) => {
        state.isLoading = false;
        state.error = action.payload;
      },
      prepare: (error?: unknown) => ({ payload: getErrors(error) }),
    },
  },
});

export const {
  setNewPasswordLoading,
  setNewPasswordSuccess,
  setNewPasswordError,
} = setNewPasswordSlice.actions;

export default setNewPasswordSlice.reducer;

export function setNewPassword(credentials: Record<string, unknown>) {
  return (dispatch: AppDispatch) => {
    dispatch(setNewPasswordLoading());

    return api.auth
      .setNewPassword(credentials)
      .then(() => {
        dispatch(setNewPasswordSuccess());
        history.push(localizeWithCurrentUrl('/sign-in'));
      })
      .catch((err) => {
        dispatch(setNewPasswordError(err));
      });
  };
}
